import React, { useContext, useEffect, useState } from 'react';
import { SelectOptions } from '../../../../../../../model/CommonModel';
import { Select } from '../../../../../../common';
import { DoorStoreSingleContext } from '../../../../DoorModal/DoorStoreSingleContext';
import { setCardCodeOnlyTimeZone, StoreContext } from '../../../contextReader';
import styles from '../../Logic/logic.module.scss';

type Props = {
	setPreviousSelection: (number) => void;
	useDoorContext: boolean;
};

const CCOTZ: React.FC<Props> = ({ setPreviousSelection, useDoorContext }) => {
	if (useDoorContext) {
		var {
			contextStateDoor: {
				entryReader: {
					genericTimeZones,
					selections: { cardCodeOnlyTimeZone },
					unpermitted,
				},
			},
			dispatcherDoor,
		} = useContext(DoorStoreSingleContext);
	} else {
		var {
			readerState: {
				genericTimeZones,
				selections: { cardCodeOnlyTimeZone },
				unpermitted,
			},
			dispatcher,
		} = useContext(StoreContext);
	}

	const [options, setOptions] = useState<SelectOptions<string>[]>([]);
	const [isDisabled, setIsDisabled] = useState<boolean>(false);

	useEffect(() => {
		if (unpermitted.cardCodeOnlyTimeZone) {
			const unpermittedOption: SelectOptions<string>[] = [
				{
					label: unpermitted.cardCodeOnlyTimeZone.Name,
					value: unpermitted.cardCodeOnlyTimeZone.GenericId.toString(),
					id: unpermitted.cardCodeOnlyTimeZone.GenericId.toString(),
				},
			];
			setOptions(unpermittedOption);
			setIsDisabled(true);
		} else {
			setOptions(genericTimeZones.map(x => ({ label: x.Name, value: x.GenericId.toString(), id: x.GenericId.toString() })));
		}
	}, [genericTimeZones]);

	const handleOnSelectCCOTZ = (value: string) => {
		setPreviousSelection(cardCodeOnlyTimeZone);
		useDoorContext ? dispatcherDoor(setCardCodeOnlyTimeZone(Number(value))) : dispatcher(setCardCodeOnlyTimeZone(Number(value)));
	};

	return (
		<div className={styles.ccotzSection}>
			<span>
				{_('EnableCCOTZ')} ({_('CCOTZ')})
			</span>
			<div>
				<Select
					className={styles.timeZone}
					options={options}
					id='readerModalReaderTypeSelect'
					onChange={handleOnSelectCCOTZ}
					key='readerType'
					value={cardCodeOnlyTimeZone.toString()}
					disabled={isDisabled}
					getPopupContainer={() => document.getElementById('logicReaderContainer')}
				/>
			</div>
		</div>
	);
};

export { CCOTZ };
